import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import Resources from '../components/Resources/Resources';
import ClientSummaries from '../components/Resources/ClientSummaries';
import PageNotFound from '../components/PageNotFound/PageNotFound';
import Notifications from '../components/Resources/Notifications';
import ProviderServicesAgreements from '../components/Resources/ProviderServicesAgreements';
import ValueAddedProgram from '../components/Resources/ValueAddedProgram';
import OperationsManual from '../components/Resources/OperationsManual';
import Help from '../components/Help/Help';
import FAQ from '../components/Help/FAQ';
import Newsletters from '../components/Resources/Newsletters';
import { PAGE_ROUTES, TOP_ROUTES } from '../scripts/routes';
import CustomLoading from '../components/shared/CustomLoading';
import ProviderEducationLibrary from '../components/Resources/ProviderEducationLibrary';
import Compliance from '../components/Compliance/Compliance';
import PractitionerEducationLibrary from '../components/Resources/PractitionerEducationLibrary';
import PractitionerServicesAgreements from '../components/Resources/PractitionerServicesAgreements';
import Forms from '../components/Resources/Forms';
import PELVideo from '../components/Resources/PELVideo';
import AuthSubmission from '../components/Forms/Auth/Submit/AuthSubmission';
import ProviderPractitionerVirtualServicesAgreement from '../components/Resources/ProviderPractitionerVirtualServicesAgreement';
import ManageSubAccounts from '../components/MyAccount/ManageSubAccounts';
import CreateSubAccount from '../components/MyAccount/CreateSubAccount';
import EditSubAccounts from '../components/MyAccount/EditSubAccounts';
import AccountManagement from '../components/MyAccount/AccountManagement';
import MyAccount from '../components/MyAccount/MyAccount';
import StaticContentSkeleton from '../components/StaticContentPage/StaticContentSkeleton';
import SelectClinicLocation from '../components/SelectClinicLocation/SelectClinicLocation';
import Layout from '../components/shared/Layout';

const MemberAgreementsPage = lazy(
	() => import('../components/MemberAgreementsPage/MemberAgreementsPage')
);
const StaticContentPage = lazy(
	() => import('../components/StaticContentPage/StaticContentPage')
);
export const unauthorizedCallback = () => {
	const encodedUrl = encodeURIComponent(window.location.href);
	window.location.href = `/identity/login?redirect=${encodedUrl}`;
};
export const postLoginUnauthorizedCallback = () => {
	window.location.href = `/ASH/default.aspx`;
};
export const useRoutesList = () => [
	{
		path: '',
		element: <Layout />,
		children: [
			{
				path: TOP_ROUTES.resources,
				element: <Resources />,
				children: [
					{
						path: PAGE_ROUTES.clientSummaries,
						element: <ClientSummaries />,
					},
					{
						path: PAGE_ROUTES.notifications,
						element: <Notifications />,
					},
					{
						path: PAGE_ROUTES.providerServiceAgreements,
						element: <ProviderServicesAgreements />,
					},
					{
						path: PAGE_ROUTES.practitionerServiceAgreements,
						element: <PractitionerServicesAgreements />,
					},
					{
						path: PAGE_ROUTES.providerPractitionerVirtualServicesAgreement,
						element: (
							<ProviderPractitionerVirtualServicesAgreement />
						),
					},
					{
						path: PAGE_ROUTES.valueAddedProgram,
						element: <ValueAddedProgram />,
					},
					{
						path: PAGE_ROUTES.operationsManual,
						element: <OperationsManual />,
					},
					{
						path: PAGE_ROUTES.forms,
						element: <Forms />,
					},
					{
						path: PAGE_ROUTES.newsletters,
						element: <Newsletters />,
					},
					{
						path: PAGE_ROUTES.practitionerEducationLibrary,
						element: <PractitionerEducationLibrary />,
					},
					{
						path: PAGE_ROUTES.providerEducationLibrary,
						element: <ProviderEducationLibrary />,
					},
					{
						path: `${PAGE_ROUTES.practitionerEducationLibrary}/:video`,
						element: <PELVideo />,
					},
				],
			},
			{
				path: TOP_ROUTES.compliance,
				element: <Compliance />,
			},
			{
				path: TOP_ROUTES.help,
				element: <Help />,
				children: [
					{
						path: PAGE_ROUTES.faq,
						element: <FAQ />,
					},
				],
			},
			{
				path: TOP_ROUTES.termsAndConditions,
				element: (
					<Suspense fallback={<StaticContentSkeleton />}>
						<StaticContentPage />
					</Suspense>
				),
			},
			{
				path: TOP_ROUTES.privacyStatement,
				element: (
					<Suspense fallback={<StaticContentSkeleton />}>
						<StaticContentPage type='PrivacyStatement' />
					</Suspense>
				),
			},
			{
				path: TOP_ROUTES.memberAgreements,
				element: (
					<Suspense fallback={<CustomLoading />}>
						<MemberAgreementsPage />
					</Suspense>
				),
			},
			{
				path: TOP_ROUTES.account,
				element: <MyAccount />,
				children: [
					{
						path: PAGE_ROUTES.editSubAccounts,
						element: <EditSubAccounts />,
					},
					{
						path: PAGE_ROUTES.accountManagement,
						element: <AccountManagement />,
					},
					{
						path: PAGE_ROUTES.manageSubAccounts,
						element: <ManageSubAccounts />,
					},
					{
						path: PAGE_ROUTES.createSubAccount,
						element: <CreateSubAccount />,
					},
				],
			},
			{
				path: TOP_ROUTES.switchClinicLocation,
				element: (
					<Suspense fallback={<CustomLoading />}>
						<SelectClinicLocation />
					</Suspense>
				),
			},
			{
				path: TOP_ROUTES.confirmClinicLocation,
				element: (
					<Suspense fallback={<CustomLoading />}>
						<SelectClinicLocation />
					</Suspense>
				),
			},
			{
				path: 'forms',
				element: <Outlet />,
				children: [
					{
						path: 'auth',
						element: <Outlet />,
						children: [
							{
								path: 'submit',
								element: <AuthSubmission />,
							},
						],
					},
				],
			},
			{
				path: '*',
				element: <PageNotFound />,
			},
		],
	},
];
